import {
    Button,
    FormControl,
    FormLabel,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Textarea,
    useToast,
} from "@chakra-ui/react";
import React, {useState} from "react";

export default function DeleteBellSetupModal({handleBlockUserModal, userId, isOpen, handleUserBlock}) {
    console.log("isOpen", isOpen)
    const toast = useToast();

    const [remarks, setRemarks] = useState("");

    const handleInputChange = (e) => {
        setRemarks(e.target.value);
    };

    const handleSubmit = () => {
        try {
            handleUserBlock(userId, remarks);
            toast({
                title: "User Blocked!",
                description: "The user has been successfully blocked.",
                status: "success",
                duration: 5000,
                isClosable: true,
            });
        } catch (error) {
            console.error(error);
            toast({
                title: "Error!",
                description: "Failed to block the user. Please try again.",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={() => handleBlockUserModal(false)} size="2xl">
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>Delete Notice</ModalHeader>
                <ModalCloseButton/>
                <ModalBody>
                    <FormControl>
                        <FormLabel>Remarks</FormLabel>
                        <Textarea
                            value={remarks}
                            onChange={handleInputChange}
                            placeholder="Enter remarks for deleting the notice"
                        />
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" onClick={() => handleBlockUserModal(false)}>
                        Cancel
                    </Button>

                    <Button colorScheme="red" mr={3} onClick={handleSubmit}>
                        Block
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}